import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from '../utils/constants';
import Modal from "react-modal";
import StepHeader from '../screens/registration/stepHeader'
import { useLocation } from 'react-router-dom'
Modal.setAppElement("#root");


// {head,subHeader}
const ExhibitionHeader = ({ isSteper }) => {

  const history = useNavigate();
  const [isLoading, setLoader] = useState(false);
  const marqueeRef = useRef(null);

  const loadScripts = () => {
    // This array contains all the files/CDNs 
    // const dynamicScripts = [
    //   'js/jquery.sticky.js',
    //   'js/metisMenu.min.js',
    //   'js/metisMenu-active.js',
    //   'js/main.js',
    //   'js/azia.js'
    // ];

    // for (let i = 0; i < dynamicScripts.length; i++) {
    //   const node = document.createElement('script');
    //   node.src = dynamicScripts[i];
    //   node.type = 'text/javascript';
    //   node.async = false;
    //   document.getElementsByTagName('head')[0].appendChild(node);
    // }
  }

  useEffect(() => {
    loadScripts();

  }, []);



  const onLogoutClick = () => {
    localStorage.clear();
    // history.push('/login');
  }

  const openPdf = () => {
    var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
    window.open(URL, null);
  }

  return (
    <>
      {isLoading ? (
        <Loader></Loader>
      ) : (
        null
      )}
      {/* app-Header */}

      <div className="app-header header sticky login-page-header-space">
        <div className="container-fluid main-container " style={{ justifyContent: 'space-between' }}>
          <div className="d-flex" style={{ float: 'left' }}>

            <div class="side-header">
              <a class="header-brand1" >
                <img src="../images/itme-right-logo.png" class="header-brand-img header-brand-img-1 light-logo1 m-0" alt="top-left logo" />
              </a>
            </div>
            {/* <div className='mobile-logo'>
              <img src="../images/itme-right-logo.png" class="" alt="top-left logo" />
            </div> */}
            <h5 className="mt-md-2 header-logo-name text-white ms-4" style={{marginLeft:'7rem'}}>INDIA ITME SOCIETY<br></br>    Trusted name for Quality and Commitment    </h5>
          </div>
          {useLocation().pathname != '/' && <div>
            <strong>
              <h3 className="text-end innerpage-text text-white login-cor-text">For new corporate site please <a href='https://corporate.india-itme.com' target='blank' className='header-login-a'>click here</a></h3>
            </strong></div>
          }
          <div className="marquee-text">
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="5"
              ref={marqueeRef}
              onMouseOver={() => marqueeRef.current?.stop()}
              onMouseOut={() => marqueeRef.current?.start()}
            >
              <b>Disclaimer and Ownership:</b> {disclaimer}
            </marquee>
          </div>
        </div>

        {isSteper ? (
          // <div className="row ">
          //   <div className="step-namev2">
          //     <p>Choose your Exhibition</p>
          //   </div>
          // </div>


          <div className="breadcrumb-for-access" style={{ left: "0px", marginTop: "72px !important" }}>
            <h6 className="mb-0 py-2 text-white px-3">Choose your Exhibition</h6>
          </div>

        ) : (null)}


      </div>
      {/* /app-Header */}
    </>
  );
}
export default ExhibitionHeader;

